import { Colors } from './colors';

export const RestProfiles = {
  GET: Colors.blue,
  POST: Colors.green,
  PUT: Colors.neonOrange,
  PATCH: Colors.orange,
  DELETE: Colors.red
};
